export default [
	{
		dataIndex: 'created_at',
		key: 'created_at',
		title: 'Date Time',
		align: 'center',
		width: 145,
		scopedSlots: {customRender: 'datetime'}
	}, {
		key: 'type',
		title: 'Type',
		scopedSlots: {customRender: 'mutationType'}
	}, {
		key: 'transaction',
		title: 'Reference',
		scopedSlots: {customRender: 'reference'}
	}, {
		key: 'product_name',
		title: 'Product Name',
		scopedSlots: {customRender: 'product'}
	}, {
		dataIndex: 'amount',
		key: 'amount',
		title: 'Amount',
		scopedSlots: {customRender: 'amount'}
	}, {
		key: 'balance',
		title: 'Balance',
		children: [
			{
				dataIndex: 'balance_before',
				key: 'balance_before',
				title: 'Before',
				scopedSlots: {customRender: 'balanceBefore'}
			}, {
				dataIndex: 'balance_after',
				key: 'balance_after',
				title: 'After',
				scopedSlots: {customRender: 'balanceAfter'}
			}
		]
	}, {
		key: 'loan',
		title: 'Loan',
		children: [
			{
				dataIndex: 'loan_balance_before',
				key: 'loan_balance_before',
				title: 'Before',
				scopedSlots: {customRender: 'loanBalanceBefore'}
			}, {
				dataIndex: 'loan_balance_after',
				key: 'loan_balance_after',
				title: 'After',
				scopedSlots: {customRender: 'loanBalanceAfter'}
			}
		]
	}
]
